import React, { useContext } from "react";
import { MenuTemplate } from "../../components/Menu/MenuTemplate";
import Footer from "../../components/Footer"
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { api } from "../../services/api";
import { Header } from "../../components/Header";
import { PaginatorContext } from "../../providers/Paginator";
import Loading from "../../components/Loading";
import { useMediaQuery } from "react-responsive";
import RouteTitleManager from "../../utils/RouteTitleManager";
import { DrawerContext } from "../../components/navbar/DrawerContext";

export const Layout = ({ children }) => {
  const { setEvent } = useContext(PaginatorContext)
  const isMobile = useMediaQuery({ query: `(max-width: 770px)` });
  const param = useParams();
  const [state, setState] = useState({
    showResult: false,
    apiMessage: "",
    error: null
  });
  const [evento, setEvento] = useState();
  const [loading, setLoading] = useState(true);
  const { drawerLoading, setDrawerLoading } = useContext(DrawerContext);

  useEffect(() => {
    const callApi = async () => {
      setDrawerLoading(true);
      try {
        const response = await api.eventos.get(param.id);
        if (response.status === "success") {
          const data = response.data.evento;
          setEvento(data);
          await setEvent(data.evento)
          return data;
        }
      } catch (error) {
        setState({
          ...state,
          error: "Error en la Red.",
        });
      } finally {
        setLoading(false);
        setDrawerLoading(false);
      }
    };
    callApi();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <RouteTitleManager />
      <div className="body d-flex" style={{ height: "100%" }}>
        {/* {!isMobile && (
          <MenuTemplate id='menu-template' evento={evento} />
        )} */}
        <div style={{
          flex: "1 1 0%",
          width: "100%",
          transition: "margin-left 0.3s ease-in-out",
          /* marginLeft: !isMobile && drawerOpen ? "280px" : "0", */
          /*  marginTop: isMobile ? "56px" : "72px" */
        }}>
          {evento &&
            <div className="h-100 d-flex flex-column">
              <Header evento={evento}></Header>
              <div className="flex-grow-1">
                {children}
              </div>
            </div>
          }
        </div>
      </div>

      <Footer />
    </>
  )
}

export default Layout;